import { SVGAttributes } from 'react';

const Bookable = (props: SVGAttributes<SVGElement>) => (
    <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M38 28.396a9.599 9.599 0 1 1-9.599-9.598"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m38 21.197-8.75 8.75a1.198 1.198 0 0 1-1.697 0l-2.751-2.75M17.603 37.995H4.4a2.4 2.4 0 0 1-2.4-2.4V4.4A2.4 2.4 0 0 1 4.4 2H29.6a2.4 2.4 0 0 1 2.4 2.4v11.998"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.189 22.044h-4.8a1.2 1.2 0 0 1-1.2-1.2v-3.6M6.79 14.704l7.199-6 7.199 6"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Bookable;
